import { useEffect } from 'react';
import Swiper from 'swiper';
import Header from '../components/Header'
import Footer from '../components/Footer.jsx';
import RightPanelMobile from '../components/RightPanelMobileToIns.jsx';

import  '../Assets/js/generalui.js'
import  '../Assets/js/datetimefunc.js'
import  '../Assets/js/countrycode.js'
import  '../Assets/js/messagelang.js'
import  '../Assets/js/index.js'

window.Swiper = Swiper;

function Home()
{
  useEffect(() =>
  {
    window.CallDefaultFunction("Index");
  }, []);

  // Append Body Element To 'root' -----------------------------------------------------
  return(
    <>
      <div className="basic">

        <Header/>

        <div className="TopBottomIndexSection TopIndexSection">
          <div className="MainBackgroundAnimateContainer" id="MainBackgroundAnimateContainer">
            <img style={{opacity: 0}} className="MainBackgroundAnimate" id="MainTopBackground" />
            <div className="loading_grey" style={{width: '100%', height: '100%', position: 'absolute', top: 0, left: 0}} id="LoadingTopBackground" />
            <div style={{backgroundColor: 'rgba(0, 0, 0, 0.2)', width: '100%', height: '100%', position: 'absolute', top: 0, left: 0}} />
          </div>
          <p className="TopTextQuotes InterRegularTextFont" style={{textAlign: 'center'}} id="HeroBannerText">Temukan <span className="InterBoldTextFont">Pengalaman</span> dan <span className="InterBoldTextFont">Penginapan Unik</span> di Indonesia<br />Hanya di <span className="InterBoldTextFont">PinginGo</span></p>
          <div className="SearchHotelIndexFormContainer">
            <div className="HoverableContentInsideInputField Unselectable" id="InputFieldSearchContainer">
              <div className="SearchHotelInputFieldContainerIndex BasicInputFieldContainer Selectable3">
                <img src="/Assets/images/ButtonIcon/searchicon.svg" className="BasicIconInsideInput" style={{marginLeft: 0}} />
                <input className="SearchHotelInputFieldIndex InterMediumTextFont" type="text" placeholder="Bali..." id="MainSearchInputField" province-slug="" current-inputed="" />
              </div>
            </div>
            <div className="CheckInOutRoomNumberContainer">
              <div className="HoverableContentInsideInputField Unselectable" id="CheckInDateInput" date={14} month={2} year={2025} onClick={()=> window.OpenDateChoiceContainer('CheckInDateInput', 'CheckOutDateInput', '', 'Start', 'HowManyNightText', 1, false, false, true, true, false, false, null)}>
                <div className="SearchHotelInputFieldContainerIndex BasicInputFieldContainer Selectable3">
                  <img className="BasicIconInsideInput" src="/Assets/images/ButtonIcon/check-in-out-icon.svg" style={{marginLeft: 0}} />
                  <div className="SearchInputFieldTopBottomTextWrapper">
                    <p className="BasicInputTextTop InterBoldTextFont" id="CheckInDateInputDateText" style={{marginTop: 0}}>14 Sept 2023</p>
                    <p className="BasicInputTextBottom InterRegularTextFont" id="CheckInDateInputDayNameText">Thursday</p>
                  </div>
                </div>
              </div>
              <div className="HoverableContentInsideInputField Unselectable" id="CheckOutDateInput" date={15} month={2} year={2025} onClick={()=> window.OpenDateChoiceContainer('CheckOutDateInput', 'CheckInDateInput', '', 'End', 'HowManyNightText', 1, false, false, true, false, false, false, null)}>
                <div className="SearchHotelInputFieldContainerIndex BasicInputFieldContainer Selectable3">
                  <img className="BasicIconInsideInput" src="/Assets/images/ButtonIcon/check-in-out-icon.svg" style={{transform: 'scaleX(-1)', marginLeft: 0}} />
                  <div className="SearchInputFieldTopBottomTextWrapper">
                    <p className="BasicInputTextTop InterBoldTextFont" id="CheckOutDateInputDateText" style={{marginTop: 0}}>14 Sept 2023</p>
                    <p className="BasicInputTextBottom InterRegularTextFont" id="CheckOutDateInputDayNameText">Thursday</p>
                  </div>
                </div>
              </div>
              <div className="HoverableContentInsideInputField Unselectable" id="RoomQuotaInput" room-quota={1} onClick={(e)=> window.OpenRoomQuotaChangePanel(e.currentTarget, 'RoomQuotaTextDisplay', 'RoomQuotaToggleArrow', false, null)}>
                <div className="SearchHotelInputFieldContainerIndex BasicInputFieldContainer Selectable3">
                  <img className="BasicIconInsideInput" src="/Assets/images/ButtonIcon/room-icon.svg" style={{marginLeft: 0}} />
                  <div className="SearchInputFieldTopBottomTextWrapper">
                    <p className="BasicInputTextTop InterBoldTextFont" style={{marginTop: 0}} id="RoomQuotaTextDisplay">1 Room</p>
                    <p className="BasicInputTextBottom InterRegularTextFont" id="HowManyNightText">1 Night</p>
                  </div>
                  <img src="/Assets/images/ButtonIcon/chevron.svg" className="BasicInputFieldChevronIconSearch ToggleArrow" id="RoomQuotaToggleArrow" style={{rotate: '0deg'}} />
                </div>
              </div>
            </div>
            <div className="ContainerFlex" style={{bottom: 0}}>
              <button className="BasicTextButton BasicBoxShadow OrangeButton IndexSearchButton Selectable SearchButtonText" id="SearchButtonIndex">Search</button>
            </div>
          </div>
        </div>
        <div className="MainContentSection" id="MainContentIndex">
          <div className="SectionSeparatorContainer LoginSekarangWarningSection" style={{paddingBottom: 0}}>
            <div className="OrangeWarningContainer BasicRoundRadius HideOnMobile">
              <div style={{width: 'fit-content', height: 'fit-content', display: 'flex', margin: 'auto 0', flexDirection:'row'}}>
                <img src="/Assets/images/Icon/gift-box-login-sekarang.svg" className="BasicIconInsideOrangeContainer" style={{marginLeft: 0}} />
                <p className="LabelGreyHeaderSmallerText InterRegularTextFont" style={{margin: 'auto 0', color: '#344054'}}>Login Sekarang, Kumpulin Poin &amp; Liburan Hemat Berkali-kali!</p>
              </div>
              <div className="UserTopInfoWrapper SecondSectionLoginSekarang" style={{height: 'fit-content', width: 'fit-content', margin: 'auto', marginRight: 0}}>
                <button className="BasicTextButton BasicBoxShadow BlueButton SignInButtonTop Selectable" onClick={()=> window.InstantiateLoginPanel('')}>Masuk</button>
                <button className="BasicTextButton BasicBoxShadow SignInButtonTop Selectable" style={{color: '#475467', backgroundColor: 'transparent'}}>
                  <div style={{width: 'fit-content', height: 'fit-content', display: 'flex', margin: 'auto'}}>
                    <p>Selengkapnya</p>
                    <img src="/Assets/images/ButtonIcon/help-icon.svg" className="BasicIconInsideButton" style={{marginRight: 0}} />
                  </div>
                </button>
              </div>
            </div>
            <div className="OrangeWarningContainer BasicRoundRadius ShowOnMobile" style={{flexDirection: 'column'}}>
              <div className="FirstSectionLoginSekarang">
                <img src="/Assets/images/Icon/gift-box-login-sekarang.svg" className="BasicIconInsideOrangeContainer" style={{marginLeft: 0}} />
                <div>
                  <p className="LabelGreyHeaderText InterMediumTextFont" style={{color: '#344054'}}>Login, Dapatkan Lebih!</p>
                  <p className="LabelGreyHeaderSmallerText InterRegularTextFont">Booking lebih cepat, kumpulkan poin dari setiap pesanan &amp; sharing, bonusnya bisa dipakai buat liburan berikutnya.</p>
                </div>
              </div>
              <div className="UserTopInfoWrapper SecondSectionLoginSekarang" style={{height: 'fit-content', width: '100%'}}>
                <button className="BasicTextButton BasicBoxShadow BlueButton SignInButtonTop Selectable" onClick={()=> window.InstantiateLoginPanel('')} style={{width: '100%'}}>Masuk</button>
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer" id="SlidePopUpContainer" style={{display: 'none'}}>
            <div className="SectionContentWrapper">
              <div className="BasicPanelSwiperMainContainer">
                <div className="ContainerWithMaskEdge">
                  <div className="PopularAreasPanelContainer" id="SliderPopUpContainer">
                    <div className="swiper-wrapper">
                    </div>
                  </div>
                </div>
                <div className="PopularAreasLeftRightButtonContainer PaddingButtonLeft">
                  <button className="NextPreviousSwiperButton Selectable2 PopUpSlideButtonPrev" id="SwiperPopUpButtonPrev">
                    <img src="/Assets/images/ButtonIcon/chevron.svg" alt="" />
                  </button>
                </div>
                <div className="PopularAreasLeftRightButtonContainer PaddingButtonRight">
                  <button className="NextPreviousSwiperButton Selectable2 PopUpSlideButtonNext" id="SwiperPopUpButtonNext">
                    <img src="/Assets/images/ButtonIcon/chevron.svg" alt="" />
                  </button>
                </div>
              </div>
              <div className="swiper-pagination BasicYellowPaginationContainer swiper-pagination-clickable swiper-pagination-bullets">
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer" id="PopularTopContainerLoading">
            <div className="SectionContentWrapper">
              <div className="SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey BasicRoomHeaderTextLoad" />
              <div className="BasicPanelSwiperMainContainer">
                <div className="ContainerWithMaskEdge PopularAreasMask">
                  <div className="PopularAreasPanelContainer">
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer" style={{backgroundColor: '#FFFFFF'}}>
            <div className="SectionContentWrapper">
              <div>
                <div className="SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey BasicRoomHeaderTextLoad" />
                <div className="SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey FeaturedButtonLoad" />
              </div>
              <div className="BasicPanelSwiperMainContainer">
                <div className="ContainerWithMaskEdge">
                  <div className="HotelRoomPanelSwiperContainer TrendingHotelsSwiperContainer">
                    <div className="BasicHotelListPanelSwiperWrapper" style={{display: 'flex'}}>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer" style={{backgroundColor: '#FFFFFF', display: 'none'}}>
            <div className="SectionContentWrapper">
              <p className="SectionHeaderTextIndex InterRegularTextFont">👍Rekomendasi Penginapan untuk Anda</p>
              <div className="ContainerWithMaskEdge">
                <div className="FeaturedButtonContainer">
                  <div className="swiper-wrapper">
                    <button className="FeaturedButtonIndex FeaturedButtonSelected InterBoldTextFont Selectable swiper-slide">Bali</button>
                    <button className="FeaturedButtonIndex InterBoldTextFont Selectable swiper-slide">Yogyakarta</button>
                    <button className="FeaturedButtonIndex InterBoldTextFont Selectable swiper-slide">Malang</button>
                  </div>
                </div>
              </div>
              <div className="NoFeaturedPropertyFoundContainer">
                <img src="/Assets/images/ButtonIcon/no-featured.svg" className="NoFoundIcon" />
                <p className="NoFoundHeaderText InterBoldTextFont">No Featured Property Found</p>
                <p className="NoFoundMessageText InterRegularTextFont">Featured property will come to this city</p>
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer" id="ExtraLoadingContent">
            <div className="SectionContentWrapper">
              <div className="SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey" style={{width: '20%'}} />
              <div className="BasicPanelSwiperMainContainer">
                <div className="ContainerWithMaskEdge">
                  <div className="HotelRoomPanelSwiperContainer TrendingHotelsSwiperContainer">
                    <div className="BasicHotelListPanelSwiperWrapper" style={{display: 'flex'}}>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer" id="ExtraLoadingContent2">
            <div className="SectionContentWrapper">
              <div className="SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey" style={{width: '20%'}} />
              <div className="BasicPanelSwiperMainContainer">
                <div className="ContainerWithMaskEdge">
                  <div className="HotelRoomPanelSwiperContainer TrendingHotelsSwiperContainer">
                    <div className="BasicHotelListPanelSwiperWrapper" style={{display: 'flex'}}>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer">
            <div className="SectionContentWrapper">
              <div className="DaftarkanContentContainer">
                <div className="move-rect">
                  <img/>
                </div>
                <div className="loading_grey ImageFullCover" />
                <div className="DaftarkanDescContainer">
                  <p className="SectionHeaderTextIndex2 InterMediumTextFont">Daftarkan Penginapan Anda di <img src="/Assets/images/Icon/pingingo-icon.svg" /></p>
                  <p className="LabelGreyHeaderSmallerText InterRegularTextFont">Perlihatkan Keindahan Alam Penginapan Anda: Jadilah Hidden Gem, Glamping, Villa, atau Resort dengan Pengalaman Menginap Tak Terlupakan</p>
                  <button className="BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable">
                    Gabung Sekarang
                    <a className="HREFInsideContainer ListingMitraButtons" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <RightPanelMobile/>

      <Footer/>
    </>
  )
}

export default Home